import imagesLoaded from "imagesloaded";

var allItems;

function resizeGridItem(item) {
    const grid = document.getElementsByClassName("category-masonry")[0];
    const rowHeight = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-auto-rows'));
    const rowGap = parseInt(window.getComputedStyle(grid).getPropertyValue('grid-row-gap'));
    const rowSpan = Math.ceil((item.querySelector('.content').getBoundingClientRect().height + rowGap) / (rowHeight + rowGap));
    item.style.gridRowEnd = "span " + rowSpan;
}

function resizeAllGridItems() {
    allItems = document.getElementsByClassName("item");
    for (let x = 0; x < allItems.length; x++) {
        resizeGridItem(allItems[x]);
    }
}

function resizeInstance(instance) {
    const item = instance.elements[0];
    resizeGridItem(item);
}

window.onload = resizeAllGridItems;
window.addEventListener("resize", resizeAllGridItems);

allItems = document.getElementsByClassName("item");
for (let x = 0; x < allItems.length; x++) {
    imagesLoaded(allItems[x], resizeInstance);
}
